import React from 'react';
import {connect} from "react-redux";
import l10n from "../../l10n/localization";
import * as utils from "../../utils/fog";
import SelectCurrencies from "./fields/SelectCurrencies";
import SelectVessels from "./fields/SelectVessels";
import SelectUnderwriters from "./fields/SelectUnderwriters";
import SelectClients from "./fields/SelectClients";
import * as fogActions from "../../actions/fog";
import * as currencyActions from "../../actions/currency";
import * as clientActions from "../../actions/client";
import * as underwriterActions from "../../actions/underwriter";
import * as vesselActions from "../../actions/vessel";
import Loader from "../common/Loader";
import Validate from 'validate.js';
import validation from '../../validation/fog';
import * as selected from "../../actions/selected";
import Checkbox from "./fields/Checkbox";
import SelectCoverType from "./fields/SelectCoverType";
import * as utilsCommon from "../../utils/utils";
import Toggle from "./fields/Toggle";
import CWForm from "./CWForm";
import WarningBoat from "./fields/WarningBoat";

class FogForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            labelText: null,
            item: this.props.item,
            isDirty: false,
            schema: {
                type: "object",
                properties: {
                    reference: {
                        type: "string",
                        title: l10n.fog.fileNb,
                    },
                    overageClientRate: {
                        type: "number",
                        title: l10n.fog.overageClientRate,
                    },
                    overageUnderwriterRate: {
                        type: "number",
                        title: l10n.fog.overageUnderwriterRate,
                    },
                    overage: {
                        type: "boolean",
                        title: l10n.fog.overage,
                    },
                    client: {
                        type: "string",
                        title: utilsCommon.notNullNorUndefined(this.props.item) &&
                        utilsCommon.notNullNorUndefined(this.props.item.client) ? 'If this value is changed, related cargoes will lose their Client Rate' : '',
                        depth: this.props.depth,
                        openDrawer: this.props.openDrawer,
                    },
                    currency: {
                        type: "string",
                        title: l10n.fog.currency,
                        depth: this.props.depth,
                        openDrawer: this.props.openDrawer,
                    },
                    vessel: {
                        type: "string",
                        title: l10n.fog.vessel,
                        depth: this.props.depth,
                        openDrawer: this.props.openDrawer,
                    },
                    voyageNb: {
                        type: "string",
                        title: l10n.fog.voyageNb,
                    },
                    underwriter: {
                        type: "string",
                        title: utilsCommon.notNullNorUndefined(this.props.item) &&
                        utilsCommon.notNullNorUndefined(this.props.item.underwriter) ? 'If this value is changed, related cargoes will lose their Underwriter Rate' : '',
                        depth: this.props.depth,
                        openDrawer: this.props.openDrawer,
                    },
                    coverType: {
                        type: "string",
                        title: l10n.coverType.name,
                        enum: utils.getCoverTypesEnum('ENUM'),
                        enumNames: utils.getCoverTypesEnum('ENUM_NAMES')
                    },
                    notes: {
                        type: "string",
                        title: l10n.fog.notes,
                    },
                    archived: {
                        type: "boolean",
                        title: l10n.fog.archived,
                    }
                }
            },
            uiSchema: {
                id: {"ui:widget": "hidden"},
                archived: {
                    "ui:field": "toggle",
                },
                reference: {
                    "ui:readonly": true
                },
                currency: {
                    "ui:field": "selectCurrencies",
                },
                vessel: {
                    "ui:field": "selectVessels",
                },
                underwriter: {
                    "ui:field": "selectUnderwriters",
                },
                client: {
                    "ui:field": "selectClients",
                },
                coverType: {
                    "ui:field": "selectCoverType",
                    "ui:emptyValue": ""
                },
                overage: {
                    "ui:widget": "radio",
                    "ui:field": "checkbox",
                },
                notes: {
                    "ui:widget": "textarea",
                    "ui:options": {
                        rows: 10
                    },
                    "ui:emptyValue": ""
                },
                voyageNb: {
                    "ui:emptyValue": ""
                }
            },
            fields: {
                selectCurrencies: SelectCurrencies,
                selectVessels: SelectVessels,
                selectUnderwriters: SelectUnderwriters,
                selectClients: SelectClients,
                selectCoverType: SelectCoverType,
                checkbox: Checkbox,
                toggle: Toggle,
            },
            isDisabled: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedUnderwriter === null && nextProps.selectedUnderwriter !== null) {
            this.setState({...this.state, item: {...this.state.item, underwriter: nextProps.selectedUnderwriter}});
        }
        if (this.props.selectedVessel === null && nextProps.selectedVessel !== null) {
            this.setState({...this.state, item: {...this.state.item, vessel: nextProps.selectedVessel}});
        }
        if (this.props.selectedClient === null && nextProps.selectedClient !== null) {
            this.setState({...this.state, item: {...this.state.item, client: nextProps.selectedClient}});
        }
    }

    componentWillUnmount() {
        this.props.dispatch(selected.unselectedUnderwriter());
        this.props.dispatch(selected.unselectedClient());
        this.props.dispatch(selected.unselectedVessel());
        this.props.dispatch(fogActions.clearFormDataFog());
    }

    componentWillMount() {
        this.loadCurrentForm();
    }

    loadCurrentForm = () => {
        this.props.dispatch(clientActions.fetchClients(true));
        this.props.dispatch(underwriterActions.fetchUnderwriters(true));
        this.props.dispatch(vesselActions.fetchVessels(true));
        this.props.dispatch(currencyActions.fetchCurrencies(true));
        this.getFormData();
    };

    componentDidMount() {
        this.updateOverageLabel(true);
    }

    updateOverageLabel = (flag) => {
        let date = (new Date()).getFullYear();

        //this.props.dispatch(fogActions.warningBoat('test'));

        if(flag) {
            if(this.props.item.vessel) {
                if(this.props.item.vessel.year) {
                    if((date - this.props.item.vessel.year) >= 20){
                        this.setState({labelText : ` WARNING OLD VESSEL - ${(date - this.props.item.vessel.year)} years`});
                    } else {
                        this.setState({labelText : null});
                    }
                }
            }
        } else {
            this.props.vessels.map((vessel)=> {
                if(vessel.id === this.props.formData.vessel){
                    if(vessel.year) {
                        if((date - vessel.year) >= 20){
                            this.setState({labelText : ` WARNING OLD VESSEL - ${(date - vessel.year)} years`});
                        } else {
                            this.setState({labelText : null});
                        }
                    }
                }
                return vessel;
            });
        }
    };

    getFormData = () => {
        let currentItem = null;
        if (utilsCommon.notNullNorUndefined(this.state.item)) {
            if (!utilsCommon.notNullNorUndefined(this.state.item.id)) {
                currentItem = this.props.fogs.getById(this.props.newlyCreatedElement);
            } else {
                currentItem = this.props.fogs.getById(this.state.item.id);
            }
        }
        this.props.dispatch(fogActions.updateFormDataFog(utils.fogToForm(utilsCommon.notNullNorUndefined(currentItem) ? currentItem.original : {currency: {id: "2"}})));
    };

    onSubmit = ({formData}) => {

        let form = Object.assign({}, {...formData});
        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    if (form.overage === undefined) {
                        form.overage = false;
                    }
                    if (form.brokerageReturn === undefined || form.brokerageReturn === null) {
                        form.brokerageReturn = false;
                    }

                    if (utilsCommon.notNullNorUndefined(this.state.item) && utilsCommon.notNullNorUndefined(formData) && this.state.item.archived === false && formData.archived === true) {
                        this.props.dispatch(fogActions.edit(form, true, this.props.displayAll));
                    } else {
                        this.props.dispatch(fogActions.edit(form, false, this.props.displayAll));
                    }
                })
            } else {
                let doRedirect = false;

                if (utilsCommon.notNullNorUndefined(this.state.item) && utilsCommon.notNullNorUndefined(formData) && this.state.item.archived === false && formData.archived === true) {
                    doRedirect = true;
                }
                this.setState({item: formData}, () => {
                        this.props.dispatch(fogActions.edit(form, doRedirect, this.props.displayAll));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                if (form.overage === undefined) {
                    form.overage = false;
                }
                if (form.brokerageReturn === undefined || form.brokerageReturn === null) {
                    form.brokerageReturn = false;
                }

                this.props.dispatch(fogActions.add(form));
            })
        }

        this.props.dispatch(fogActions.updateFormDataFog(formData));
        this.setState((state) => {return {...state, isDirty: false, formData: formData};});
        this.updateOverageLabel(false);
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {

            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }

        return errors;
    };

    handleError = () => {
        this.props.dispatch(fogActions.errorMessage(l10n.validation.form_error));
    };

    handleChange = (formData) => {
        if(!this.state.isDirty) {
            this.setState({isDirty: true}, this.updateOverageLabel);
        }
        this.props.dispatch(fogActions.updateFormDataFog(formData.formData));
        this.updateOverageLabel(false);
    };
    closeWarning = () => {
        this.setState({labelText: null});
    };

    render() {

        if (this.props.loading || this.props.loadingClient || this.props.loadingUnderwriter
            || this.props.loadingVessel || this.props.loadingCurrency) {
            return (<div><Loader /></div>)
        }

        let formClassName = (this.state.isDirty) ? 'fog-form dirty':'fog-form';

        return (
            <div className={formClassName}>
                {this.props.title !== undefined && <h1>{this.props.title}</h1>}
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.props.formData}
                    onSubmit={this.onSubmit}
                    showErrorList={false}
                    liveValidate={true}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    validate={this.validate}
                    onError={this.handleError}
                    fields={this.state.fields} >
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
                {(this.state.labelText && !this.props.formData.overage)? <WarningBoat label={this.state.labelText} unmount={this.closeWarning}/> : null}
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        selectedUnderwriter: state.selected.underwriter,
        selectedVessel: state.selected.vessel,
        selectedClient: state.selected.client,

        loading: state.fog.loading,
        fogs: state.fog.fogs,
        loadingClient: state.client.loading,
        loadingUnderwriter: state.underwriter.loading,
        loadingVessel: state.vessel.loading,
        loadingCurrency: state.currency.loading,
        vessels: state.vessel.vessels,
        saving: state.fog.saving,
        newlyCreatedElement: state.creation.newlyCreatedFog,
        displayAll: state.connect.displayAll,
        formData: state.fog.formData
    });
})(FogForm);



// WEBPACK FOOTER //
// ./src/components/forms/FogForm.js